import styled from '@emotion/styled';
import { Colors, Flex } from '@revenuemarket/cds';
import { Menu } from 'antd';

export const SearchMenu = styled(Menu)`
  background: transparent !important;
  border-inline-end: none;
  border-radius: 0;
  & .ant-menu-item-selected {
    background: ${Colors.grayOpacity04} !important;
    border-radius: 8px;
  }
`;

export const PanelWrapper = styled(Flex)`
  width: 100%;
  padding: 16px;
  border-radius: 12px;
  background-color: ${Colors.white};
  border: 1px solid ${Colors.grayOpacity07};
`;
